import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Compact footer pager shared by the paginated admin tables.
export default function TablePager({ page, totalPages, total, pageSize, onPage }) {
  if (!total || total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const btn =
    "p-1.5 rounded-lg bg-white/5 hover:bg-white/10 text-white/70 disabled:opacity-30 disabled:cursor-default transition-colors";
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-white/10 text-xs text-white/55">
      <span>
        Showing <span className="text-white/80 font-mono">{from}</span>–
        <span className="text-white/80 font-mono">{to}</span> of{" "}
        <span className="text-white/80 font-mono">{total}</span>
      </span>
      <div className="flex items-center gap-2">
        <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)} className={btn} title="Previous page">
          <ChevronLeft size={16} />
        </button>
        <span className="min-w-[84px] text-center">
          Page <span className="text-white/80 font-semibold">{page}</span> / {totalPages}
        </span>
        <button type="button" disabled={page >= totalPages} onClick={() => onPage(page + 1)} className={btn} title="Next page">
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
